import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const TopicNodeToggleIcon = ({ node, onToggle, ...rest }) =>
(
  <Box onClick={onToggle} {...rest}>
    {node.isOpen ?
      <KeyboardArrowDownIcon fontSize="small" /> :
      <KeyboardArrowRightIcon fontSize="small" />
    }
  </Box>
);

export default TopicNodeToggleIcon;
